const initialState = {
  active: false,
  app: "",
  config: null,
  alloBrainSimulationBody: "{}",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "toggle":
      return {
        ...state,
        app: action.app,
        active: !state.active,
        config: action.config,
      };
    case "toggle-webapp-preview":
      return {
        ...state,
        preview: !state.preview,
        buttonPosition: action.buttonPosition,
        app: "web-app",
      };
    case "update-allo-brain-simulation-body":
      return {
        ...state,
        alloBrainSimulationBody: action.data,
      };
    default:
      return initialState;
  }
};

export { reducer, initialState };
